/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Continue_GoogleInputs */

const en_portal_x13_continue_google = /** @type {(inputs: Portal_X13_Continue_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Google`)
};

/** @type {(inputs: Portal_X13_Continue_GoogleInputs) => LocalizedString} */
const ar_portal_x13_continue_google = en_portal_x13_continue_google;

/** @type {(inputs: Portal_X13_Continue_GoogleInputs) => LocalizedString} */
const he_portal_x13_continue_google = en_portal_x13_continue_google;

/** @type {(inputs: Portal_X13_Continue_GoogleInputs) => LocalizedString} */
const ur_portal_x13_continue_google = en_portal_x13_continue_google;

/** @type {(inputs: Portal_X13_Continue_GoogleInputs) => LocalizedString} */
const es_portal_x13_continue_google = en_portal_x13_continue_google;

/** @type {(inputs: Portal_X13_Continue_GoogleInputs) => LocalizedString} */
const fr_portal_x13_continue_google = en_portal_x13_continue_google;

/** @type {(inputs: Portal_X13_Continue_GoogleInputs) => LocalizedString} */
const de_portal_x13_continue_google = en_portal_x13_continue_google;

/** @type {(inputs: Portal_X13_Continue_GoogleInputs) => LocalizedString} */
const pt_portal_x13_continue_google = en_portal_x13_continue_google;

/** @type {(inputs: Portal_X13_Continue_GoogleInputs) => LocalizedString} */
const hi_portal_x13_continue_google = en_portal_x13_continue_google;

/** @type {(inputs: Portal_X13_Continue_GoogleInputs) => LocalizedString} */
const bn_portal_x13_continue_google = en_portal_x13_continue_google;

/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Portal_X13_Continue_GoogleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_x13_continue_google = /** @type {((inputs?: Portal_X13_Continue_GoogleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Continue_GoogleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_x13_continue_google(inputs)
	if (locale === "he") return he_portal_x13_continue_google(inputs)
	if (locale === "ur") return ur_portal_x13_continue_google(inputs)
	if (locale === "es") return es_portal_x13_continue_google(inputs)
	if (locale === "fr") return fr_portal_x13_continue_google(inputs)
	if (locale === "de") return de_portal_x13_continue_google(inputs)
	if (locale === "pt") return pt_portal_x13_continue_google(inputs)
	if (locale === "hi") return hi_portal_x13_continue_google(inputs)
	if (locale === "bn") return bn_portal_x13_continue_google(inputs)
	return /** @type {LocalizedString} */ ("Continue with Google")
});